module.exports = __webpack_public_path__ + "static/preppedbanner-desktop-3baffb96ed23c88d107895c61fa72c4c.jpg";